import type { IStyledComponent, RuleSet } from 'styled-components'

const getStyles = ({ rules, baseStyle }: NonNullable<IStyledComponent<'web'>['componentStyle']>): RuleSet<any> =>
	baseStyle ? [...getStyles(baseStyle), ...rules] : rules

/**
 * Get all styles from a styled-component, including parent components, and
 * extract them so they can be inserted into a new component, without actually
 * inheriting from that component.
 *
 * Basically allows copying styles without assigning them to an intermediary
 * variable.
 */
export const stylesFrom = (component: IStyledComponent<'web', any>) => getStyles(component.componentStyle)
